const $ = document.querySelector.bind( document );
const header = $( 'header.stick' );
const siteBlocks = $( '.wp-site-blocks' );
const menu = header?.querySelector( '.nav-swv-menu' );
const menuNext = menu?.nextElementSibling;

document.querySelectorAll( '.wp-block-group[id^="modal-"]' ).forEach( ( modal ) => {
	const backdrop = document.createElement( 'div' );
	backdrop.className = 'swv-hash-modal-backdrop';
	backdrop.setAttribute( 'aria-hidden', 'true' );
	modal.after( backdrop );
	document.body.append( modal, backdrop );
} );

/**
 * Open modal.
 *
 * @return void
 */
const openModal = ( event ) => {
	$( 'html' ).classList.add( 'has-open-modal' );

	stickHeader( event );
}

/**
 * Close modal.
 *
 * @return void
 */
const closeModal = () => {
	$( 'html' ).classList.remove( 'has-open-modal' );
}

/**
 * Stick header
 *
 * @return void
 */
const stickHeader = ( event ) => {
	if ( ! event.target.closest( '.is-sticky' ) ) {
		header.addEventListener( 'mouseleave', unstickHeader );
	}

	header.classList.add( 'is-sticky' );
}

/**
 * Unstick header
 *
 * @return void
 */
const unstickHeader = () => {
	header.classList.remove('is-sticky');

	header.removeEventListener( 'mouseleave', unstickHeader );
}

/**
 * Add sticky menu event listener.
 *
 * @param MouseEvent event Mouse event.
 * @return void
 */
const addStickyMenuEventListener = ( event ) => {
	siteBlocks.removeEventListener( 'mousemove', addStickyMenuEventListener );

	menuNext.addEventListener( 'mouseenter', stickHeader );

	// Stick immediately when cursor is already on menu.
	if ( event.target.closest( '.nav-swv-menu, .nav-swv-menu + *' ) ) {
		menuNext.addEventListener( 'mousemove', stickHeader );
	}
}

/**
 * Event listeners.
 */
if ( menu?.querySelector( '.nav-swv-submenu' ) ) {
	menu.addEventListener( 'mouseenter', openModal );
	menu.addEventListener( 'mouseleave', closeModal );
}

if ( menuNext && siteBlocks ) {
	siteBlocks.addEventListener( 'mousemove', addStickyMenuEventListener );
}
